"use client";

import { useState } from "react";

const Hero = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div
      data-testid="homepage-hero"
      className="bg-white from-bgHome via-[#172035] to-bgHome dark:bg-gradient-to-r"
    >
      <div className="relative isolate overflow-hidden pt-14">
        <div className='absolute inset-x-0 bottom-0 -z-10 h-[90vh] bg-[url("/images/Container.png")] bg-contain bg-bottom bg-no-repeat'></div>

        <div className="mx-auto max-w-2xl pb-72 pt-32">
          <div className="hidden sm:mb-8 sm:flex sm:justify-center"></div>
          <div className="text-center">
            <h1 className="mx-auto max-w-lg text-4xl font-bold tracking-tight text-[#002243] dark:text-white">
              Accelerating research on the global information environment.
            </h1>
            <p className="mt-6 text-lg leading-8 text-[#002243] dark:text-gray-300">
              We provide shared engineering infrastructure, maintain
              high-quality data resources, and support access for a broad
              network of researchers—enabling rigorous analysis and informed
              policy across liberal democracies.
            </p>
            <div className="mt-10 flex items-center justify-center gap-x-6">
              <a
                href="/auth/login?screen_hint=signup&returnTo=/auth/verify-email"
                className="text-md font-semibold leading-6 text-[#002243] dark:text-white"
              >
                Start Your Research <span aria-hidden="true">→</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
